import BackgroundPattern from '../../components/BackgroundPattern';
import ComponentType from '../../types/Component';

import styles from './styles.module.scss';

type PageLayoutType = {
	title?: string;
	showFooter?: boolean;
};

const PageLayout: ComponentType<PageLayoutType> = ({ children, title, showFooter = true }) => {
	return (
		<div style={{ position: 'relative' }}>
			<BackgroundPattern />
			<div className={styles.pageLayout}>
				<div className={styles.layoutBody}>{children}</div>
			</div>
		</div>
	);
};

export default PageLayout;
